export default {
  data() {
    return {
      login_id: '',
      passwd: ''
    };
  },
  mounted() {
    const el = document.body;
    if (this.$theme.ios) {
      el.classList.add('color-theme-white');
      el.classList.remove('color-theme-blue');
    } else {
      //el.classList.add('color-theme-blue');
      el.classList.remove('color-theme-white');
    }
  },
  methods: {
    // ready
    onF7Ready(f7) {
      // 자동로그인
      var is_auto_login = (localStorage.auto_login == 'true') ? true : false;
      this.$root.$data.auto_login = is_auto_login;

      // 로그인 정보가 없을 경우 로그인 화면 표시
      var admin_id = localStorage.admin_id;
      if (admin_id == undefined  ||  admin_id == null  ||  admin_id == ''  ||  is_auto_login != true) {
        this.$f7.loginScreen.open('.login-screen');
      } else {
        this.$root.$data.login_id   = localStorage.login_id;
        this.$root.$data.login_name = localStorage.login_name;
        this.$root.$data.group_code = localStorage.group_code;
        this.$root.$data.use_barcode_limit = (localStorage.use_barcode_limit_yn == 'Y');  // 바코드 제한시간 적용
      }
    },
    // Enter key 체크
    onKeyUpLogin(event) {
      if (event.which == 13  ||  event.keyCode == 13) {
        this.$f7.input.blur(event.target);
        this.checkValue();
      }
    },
    // 로그인 입력 값 체크
    checkValue() {
      if (this.login_id.trim() == '') {
        this.$f7.toast.create({
          text: '로그인 아이디를 입력해 주세요.',
          closeTimeout: 2000
        }).open();
        return;
      }
      if (this.passwd.trim() == '') {
        this.$f7.toast.create({
          text: '비밀번호를 입력해 주세요.',
          closeTimeout: 2000
        }).open();
        return;
      }

      var formdata = new FormData();
      formdata.set('login_id', this.login_id);
      formdata.set('passwd', this.passwd);

      var _this = this;
      this.$http.post(_this.$api_base_uri + '/login', formdata, {
        timeout: 20000
      })
      .then(function(response) {
        if (response.data.result != true) {
          _this.$f7.dialog.alert(response.data.msg);

        } else {
          // 로그인정보 저장
          try {
            localStorage.admin_id = response.data.admin_id;
            localStorage.login_id = response.data.login_id;
            localStorage.login_name = response.data.login_name;
            localStorage.group_code = response.data.group_code;
            localStorage.tourist_id = response.data.tourist_id;
            localStorage.eating_house_yn = response.data.eating_house_yn;
            localStorage.goods_store_yn = response.data.goods_store_yn;
            localStorage.use_barcode_limit_yn = response.data.use_barcode_limit_yn;

            // 좌측메뉴 표시용
            _this.$root.$data.login_id = response.data.login_id;
            _this.$root.$data.login_name = response.data.login_name;
            _this.$root.$data.group_code = response.data.group_code;
            _this.$root.$data.tourist_id = response.data.tourist_id;
            _this.$root.$data.use_barcode_limit = (response.data.use_barcode_limit_yn == 'Y');
            _this.$root.$data.auto_login = (localStorage.auto_login == 'true');

          } catch(e) {
            _this.$f7.dialog.alert('로그인 정보 처리에 실패했습니다.', 'Mobile POS');
          }

          // 입력값 초기화
          _this.login_id = '';
          _this.passwd = '';

          // 로그인 화면 닫기
          _this.$f7.loginScreen.close();
        }
      })
      .catch(function(error) {
        console.log(error);
        _this.$f7.dialog.alert('로그인 처리 중 오류가 발생했습니다.<br/>잠시 후 다시 시도해 주세요.', 'Mobile POS');
      });
    }
  }
};


// WEBPACK FOOTER //
// ./src/js/login.js